import { formatCurrencyForDisplay } from '@utils'
import { tr } from 'mmfintech-commons'
import type { ReactNode } from 'react'

import './discountSavingRow.scss'

interface DiscountSavingRowProps {
  value: ReactNode
  currency?: string
  label?: string
}

export const DiscountSavingRow = ({ value, currency, label }: DiscountSavingRowProps) => {
  if (!value) return null

  return (
    <div className='discount-saving-row'>
      <span className='discount-saving-label'>{label || tr('FRONTEND.PROMO.DISCOUNT_SAVING', 'Discount Saving')}:</span>
      <span className='discount-saving-value'>
        {value} {currency && <span className='row-amount-currency'>{formatCurrencyForDisplay(currency)}</span>}
      </span>
    </div>
  )
}
